<template>
  <list-layout :tableTools="toggleTableTools">
    <template slot="header">
      <BaseHeader :content="header" />
    </template>
    <template slot="table-core">
      <base-table-pagination
        ref="baseTablePagRef"
        :total="pagination.total"
        :currentPage="pagination.currentPage"
        :perPage="pagination.pageSize"
        @changeCurrentPage="changeCurrentPage"
        @changePerPage="changePerPage"
      ></base-table-pagination>
      <div class="flex flex-row w-100">
        <base-table-refresh @applyFilters="applyFiltersHandler" />
        <base-table-searches @toggleSearchesDialog="toggleSearchesDialog" />
        <base-table-search @toggleFilters="toggleFilters" />
      </div>
    </template>
    <template slot="table-tags">
      <base-table-filter-tags  :tags="tags" @removeTag="removeFilterTagHanlder" @removeAllTags="removeAllTagsHandler" @saveTags="saveTagsHandler"/>
    </template>
    <template slot="table-component">
      <kendo-grid-component class="kendo-pointer-default"
        :spanish="spanish"
        :dataResult='kendo.dataResult'
        :kendo="kendo"
        :loading='isGeneralLoading'
        :selectedField="selectedField"
        @datastatechange='dataStateChange'
        @columnreorder='columnReorder'
        @columnssubmit='onColumnsSubmit'
        @sortchange='sortChange'
        @filterchange='filterChange'
        @selectionchange="onSelectionChange"
        @headerselectionchange="onHeaderSelectionChange">
      </kendo-grid-component>
    </template>
    <template slot="layout-extend">
      <base-table-select-actions-expand
        :visibility="hasSelected"
        :selected="rowsSelected"
        :total="rowsTotal"
        :baseDropDownVisible="accionesFinal && accionesFinal.length > 0 && hasSelected"
      >
        <template slot="commons">
          <base-button :disabled="!hasSelected" size="xs" mode="tools" @click="unselect">
            <base-icon name="vall" size="sm" class="mr-1" :ariaHidden="true"/>
            {{ $t('app.unselect') }}
          </base-button>
        </template>
        <template slot="more">
          <span v-for="action in accionesFinal" :key="action.id">
            <base-button-item-list theme="dark"  @click="executeAction(action)">
              <base-icon :name="action.icon" class="mr-2" :ariaHidden="true"/>
              {{ action.name }}
            </base-button-item-list>
          </span>
          <!-- <base-button-item-list theme="dark" @click="unlink">
            <base-icon name="unlink" class="mr-2" :ariaHidden="true"/>
              Desvincular
          </base-button-item-list> -->
        </template>
      </base-table-select-actions-expand>
      <base-footer>
        <template slot="actions">
          <base-button-responsive mode='primary' :text="labelBtnExcel" icon='excelxls' @click='exportExcel' :loading='isGeneralLoading || loadingExcel' :disabled="loadingExcel"/>
          <base-button-responsive v-if="hasModulePresentacionesAEAT && showNewTramite && this.role !== 'UsuarioConsulta'" mode="primary" :text="$t('presentations.new')" icon="plus" @click="goToNewPresentation" :loading="isGeneralLoading"/>
        </template>
      </base-footer>
      <filter-panel :panelOpen="filterPanel" @togglePanel="toggleFilters" @applyFilters="applyFiltersHandler" />
      <create-search-dialog 
        :numberSearches="numberSearches"
        :idVista="idVista" 
        :dialogOpen="saveSearchDialog" 
        :tags="tags" 
        @toggleDialog="toggleDialogSearches" 
        @applyDialog="applySearchHandler" />
      <filter-panel-searches 
        ref="filterPanelSearches" 
        :idVista="idVista" 
        :vuexnamespace="vuexnamespace" 
        :panelOpen="searchesPanel" 
        @togglePanel="toggleSearchesDialog" 
        @applyFilters="applyFiltersHandler" 
        @updateNumberSearches="updateNumberSearches"/>
    </template>
  </list-layout>
</template>

<script>
import ListLayout from '@/components/layout/ListLayout.vue'
import FilterPanel from '@/components/filters/PresentationsAEATFilter.vue'
import FilterPanelSearches from '@/components/searches/SearchesPanel.vue'
import CreateSearchDialog from '@/components/searches/CreateSearchDialog.vue'

import { i18n } from '@/i18n'
import '@progress/kendo-theme-default/dist/all.css'
import { process } from '@progress/kendo-data-query'
import KendoGridComponent from '../../components/KendoGridComponent.vue'

import { actualizarestadopresentaciones } from '@/services/app/actualizarestadopresentaciones' 
import { getNotification } from '@/services/notifications/getNotification' 
import { getPresentationsAEAT } from '@/services/notifications/getPresentationsAEAT'
import { getPresentationsAEATExcel } from '@/services/notifications/getPresentationsAEATExcel'

export default {
  name: 'presentations-aeat',
  components: {
    ListLayout,
    FilterPanel,
    FilterPanelSearches,
    CreateSearchDialog,
    KendoGridComponent,
  },
  data: function () {
    return {
      idVista: 83,
      // Searches
      numberSearches: 0,
      saveSearchDialog: false,
      searchesPanel: false,
      // All
      loadingExcel: false,
      spanish: true,
      showNewTramite: false,
      header: {
        title: i18n.t('app.presentations_aeat'),
        icon: 'config',
        breadcrumb: null,
        url: 'notification/details'
      },
      acciones: [
        { id: 1, name: i18n.t('imports.cancel'), icon: 'changestatus' },
        { id: 2, name: i18n.t('app.retry'), icon: 'retry' },
      ],
      vuexnamespace: 'neopresentations',
      selectedField: 'selected',
      filterPanel: false,
      showAllRows: true,
      loadingDataTable: false,
      notificationType: null,
      data: null,
      selected: [],
    }
  },
  computed: {
    hasModulePresentacionesAEAT () {
      return this.$store.getters['auth/hasModulePresentacionesAEAT']
    },
    accionesFinal () {
      if (this.role === 'UsuarioConsulta') return []
      let listaAccionesFinal = this.acciones.slice()

      // Si no son todos en Error no se puede cancelar
      if (this.selected.length !== this.selected.filter(x => x.idEstado === 2).length) {
        listaAccionesFinal = []
      }

      return listaAccionesFinal
    },
    labelBtnExcel: function () {
      if (this.hasSelected) return this.$i18n.t('app.export_excel') + ' (Seleccionados)'
      return this.$i18n.t('app.export_excel')
    },
    kendo: function () {
      return this.$store.getters[this.vuexnamespace + '/getKendo']
    },
    isHeadCoreReady: function () {
      return this.$store.getters.isHeadCoreReady
    },
    toggleTableTools: function () {
      return this.selected.length > 0
    },
    rowsSelected: function () {
      return this.selected.length
    },
    rowsTotal: function () {
      return this.selected.length
    },
    setLabelTowShow: function () {
      return this.showAllRows ? 'Solo Seleccionadas' : 'Ver Todas'
    },
    masterFilters: function () {
      return this.$store.getters[this.vuexnamespace + '/getMasterFilters']
    },
    isGeneralLoading: function () {
      return this.$store.getters.isLoading
    },
    headerCoreFilters: function () {
      return this.$store.getters['auth/queryHeaders']
    },
    tags: function () {
      return this.$store.getters[this.vuexnamespace + '/getTags']
    },
    pagination: function () {
      return this.$store.getters[this.vuexnamespace + '/getPaginationInfo']
    },
    columns () {
      return [
        { field: 'selected', width: '50px', headerSelectionValue: this.areAllSelected, reorderable: false, groupable: false },
        ...this.kendo.columns
      ]
    },
    areAllSelected () {
      return this.data.length === this.selected.length
    },
    hasSelected () {
      return this.selected.length > 0
    },
    role: function () {
      return this.$store.getters['auth/role']
    },
  },
  watch: {
    headerCoreFilters: {
      // immediate: true,
      deep: true,
      handler: 'headerCoreFiltersHandler'
    },
    data (val, oldVal) {
      const dataState = {
        skip: this.kendo.skip,
        take: this.kendo.take,
        sort: this.kendo.sort,
        group: this.kendo.group
      }
      this.kendo.dataResult = process(val, dataState)
      this.unselect()
    }
  },
  created: function () {
    if (this.role === 'UsuarioConsulta') {
      this.kendo.columns = this.kendo.columns.filter(x => x.field !== 'selected')
    } 
  },
  mounted: async function () {
    this.notificationType = this.$route.params.type !== null ? parseInt(this.$route.params.type) : null
    const notificationId = this.$route.params.id

    this.$store.commit(this.vuexnamespace + '/setPageSize', this.kendo.take)

    const breadcrumbs = []
    if (this.notificationType !== null && this.notificationType !== 99999) {
      breadcrumbs.push({ path: '' + this.notificationType, name: this.$i18n.t('app.notifications') })
    } else {
      breadcrumbs.push({ path: 'notifications', name: this.$i18n.t('app.notifications') })
    }
    if (this.$store.getters['app/fromRouteName'] !== null) {
      const breadcrumbHeader = this.$store.getters['app/headerBreadCrumb']
      breadcrumbs.push({ path: '', name: this.truncate(breadcrumbHeader, 30, false) })
    } else {
      await this.downloadNotificationData(notificationId)
      breadcrumbs.push({ path: '', name: this.truncate(this.Asunto, 30, false) })
      this.$store.commit('app/setheaderBreadCrumb', this.Asunto)
    }
    this.header.breadcrumb = breadcrumbs
    this.header.params = this.$route.params

    this.data = await this.applyFilters()
  },
  methods: {
    executeAction: async function (action) {
      if (!action) {
        console.error('Acción desconocida')
      } else {
        this.actionHandler(action)
      }
    },
    actionHandler: async function (action) {
      try {
        this.$store.commit('setIsLoading', true)
        const selected = this.selected
        const payload = {
          idPresentaciones: selected.map(x => x.idPresentacion),
          accion: action.id,
        }
        
        const res = await actualizarestadopresentaciones(payload)
        if (res.blnError) {
          this.doFeedback(res.msgError + ' [Código de error: ' + res.codError + ']')
        } else {
          this.doFeedback('Acción tramitada correctamente', 'success')
          this.data = await this.applyFilters()
          this.$store.dispatch('app/getAnnouncementsList')
        }
      } catch (error) {
        this.doFeedback()
      } finally {
        this.$store.commit('setIsLoading', false)
      }
    },
    updateAllSelectedHeader: function () {
      if (!this.hasSelected) {
        this.kendo.columns[0].headerSelectionValue = false
      } else {
        this.kendo.columns[0].headerSelectionValue = this.areAllSelected
      }
    },
    downloadNotificationData: async function (notificationId) {
      try {
        this.$store.commit('setIsLoading', true)
        const params = {
          idNEO: notificationId
        }
        const notification = await getNotification(params)
        if (notification.blnError) {
          this.doFeedback(notification.msgError + ' [Código de error: ' + notification.codError + ']')
        }
        this.setNotification(notification.respuesta)
      } catch (error) {
        this.doFeedback(this.$i18n.t('feedback.error.general'))
      } finally {
        this.$store.commit('setIsLoading', false)
      }
    },
    setNotification: function (notification) {
      this.Asunto = notification.Asunto ? notification.Asunto : 'Sin asunto'
    },
    toggleFilters: function () {
      this.filterPanel = !this.filterPanel
    },
    removeFilterTag: function (tag) {
      this.tags.splice(this.tags.indexOf(tag), 1)
    },
    createAppState: function (dataState) {
      this.kendo.take = dataState.take
      this.kendo.skip = dataState.skip
      if (dataState.group) {
        // eslint-disable-next-line no-return-assign
        // dataState.group.map(group => group.aggregates = this.aggregates)
      }
      this.kendo.group = dataState.group
      this.kendo.filter = dataState.filter
      this.kendo.sort = dataState.sort
    },
    dataStateChange: async function (event) {
      this.createAppState(event.data)
      this.data = await this.applyFilters()
    },
    columnReorder: function (options) {      
      this.sendUpdatedColumns(options.columns)
      this.kendo.columns.forEach((column, index) => {
        if (options.columns.filter(x => x.field === column.field).length === 0) {
          column.orderIndex = index + this.kendo.columns.length
          options.columns.push(column)
        }
      })
      this.kendo.columns = options.columns
    },
    exportExcel: async function () {
      this.$store.commit('app/setLoading', true)
      this.loadingExcel = true
      const data = this.$store.getters[this.vuexnamespace + '/getAppliedFilters']
      const params = {
        idNEO: this.$route.params.id,
        CodigoTramite: data.CodigoTramite ? data.CodigoTramite.value : null,
        DescripcionTramite: data.DescripcionTramite ? data.DescripcionTramite.value : null,
        Asunto: data.Asunto ? data.Asunto.value : null,
        Telefono: data.Telefono ? data.Telefono.value : null,
        Email: data.Email ? data.Email.value : null,
        PresentarRecurso: data.PresentarRecurso ? data.PresentarRecurso.value : null,
        Observaciones: data.Observaciones ? data.Observaciones.value : null,
        NumAsiento: data.NumAsiento ? data.NumAsiento.value : null,
        CSVRecibo: data.CSVRecibo ? data.CSVRecibo.value : null,
        URLRecibo: data.URLRecibo ? data.URLRecibo.value : null,
        FechaPresentacionDesde: data.FechaPresentacionDesde ? data.FechaPresentacionDesde.value : null,
        FechaPresentacionHasta: data.FechaPresentacionHasta ? data.FechaPresentacionHasta.value : null,
        idEstado: data.tipoPresentacionEstado ? data.tipoPresentacionEstado.value : null,
        Error: data.Error ? data.Error.value : null,
      }
      const objOrder = this.getObjOrderMixin(this.kendo.group, this.kendo.sort)
      const objColumnas = this.getColumnsGroupExcelMixin(this.kendo.columns, this.kendo.group)
      const payload = { order: objOrder.order, grupos: objColumnas }
      if (this.hasSelected) {
        const selectedIDs = this.selected.map(x => x.idPresentacion)
        payload.listaIDs = selectedIDs
      }
      try {
        const response = await getPresentationsAEATExcel(payload, params)
        const blob = new Blob([response.data], { type: response.data.type, encoding: 'UTF-8' })
        const link = document.createElement('a')
        link.href = window.URL.createObjectURL(blob)
        let filename = 'presentaciones.xlsx'
        filename = decodeURI(filename)
        link.download = filename
        link.click()
      } catch (error) {
        console.error(error)
        if (error.response?.data) {
          const errorText = await error.response.data.text()
          this.doFeedback(errorText)
        } else {
          this.doFeedback()
        }
      } finally {
        this.$store.commit('app/setLoading', false)
        this.loadingExcel = false
      }
    },
    onColumnsSubmit: function (columnsState) {
      this.sendUpdatedColumns(columnsState)
      this.kendo.columns = columnsState
    },
    sortChange: function (e) {
      let sort = e.sort
      if (Array.isArray(e)) {
        sort = e
      }
      const dataState = {
        skip: this.kendo.skip,
        take: this.kendo.take,
        sort: sort,
        group: this.kendo.group,
        filter: this.kendo.filter
      }
      this.dataStateChange({ data: dataState })
    },
    filterChange: function (filter) {
      const dataState = {
        skip: this.kendo.skip,
        take: this.kendo.take,
        sort: this.kendo.sort,
        group: this.kendo.group,
        filter: filter
      }

      this.dataStateChange({ data: dataState })
    },
    expandChange: function (event) {
      event.dataItem[event.target.$props.expandField] = !event.dataItem[event.target.$props.expandField]
    },
    applyFilters: async function (eventData) {
      this.loadingDataTable = true
      const data = this.$store.getters[this.vuexnamespace + '/getAppliedFilters']
      // console.log('applyFilters', data)
      const params = {
        idNEO: this.$route.params.id,
        CodigoTramite: data.CodigoTramite ? data.CodigoTramite.value : null,
        DescripcionTramite: data.DescripcionTramite ? data.DescripcionTramite.value : null,
        Asunto: data.Asunto ? data.Asunto.value : null,
        Telefono: data.Telefono ? data.Telefono.value : null,
        Email: data.Email ? data.Email.value : null,
        PresentarRecurso: data.PresentarRecurso ? data.PresentarRecurso.value : null,
        Observaciones: data.Observaciones ? data.Observaciones.value : null,
        NumAsiento: data.NumAsiento ? data.NumAsiento.value : null,
        CSVRecibo: data.CSVRecibo ? data.CSVRecibo.value : null,
        URLRecibo: data.URLRecibo ? data.URLRecibo.value : null,
        FechaPresentacionDesde: data.FechaPresentacionDesde ? data.FechaPresentacionDesde.value : null,
        FechaPresentacionHasta: data.FechaPresentacionHasta ? data.FechaPresentacionHasta.value : null,
        idEstado: data.tipoPresentacionEstado ? data.tipoPresentacionEstado.value : null,
        Error: data.Error ? data.Error.value : null,
      }
      const objOrder = this.getObjOrderMixin(this.kendo.group, this.kendo.sort)
      try {
        this.data = await this.getItemsData(objOrder, params)
      } catch (error) {
        this.$store.commit('setIsLoading', false)
        this.doFeedback(this.$i18n.t('feedback.error.general'))
      }
      this.updateAllSelectedHeader()
      return this.data
    },
    getItemsData: async function (objOrder, filters) {
      this.$store.commit('setAjaxRequestPending', true)
      this.$store.commit('setIsLoading', true)
      const params = {
        paginate: true,
        results: this.pagination.pageSize,
        page: this.pagination.currentPage,
        ...filters
      }
      const res = await this.getMainData(objOrder, params)
      this.data = res.respuesta
      const pagination = {
        total: res.meta?.total,
        currentPage: res.meta?.currentPage,
        totalPages: res.meta?.lastPage,
        pageSize: res.meta?.perPage
      }
      
      this.updatePersistedSortMixin()
      this.$store.commit(this.vuexnamespace + '/setPaginationInfo', pagination)
      this.$store.commit('setIsLoading', false)
      this.loadingDataTable = false
      return this.data
    },
    async getMainData (objOrder, filters) {
      const params = {
        paginate: true,
        results: this.pagination.pageSize,
        page: this.pagination.currentPage,
        ...filters
      }
      const data = await getPresentationsAEAT(objOrder, params)
      if (data.blnError === true) {
        this.doFeedback(data.msgError + ' [Código de error: ' + data.codError + ']')
      } else {
        setTimeout(() => {
          this.$nextTick(() => { 
            if (this.$refs.baseTablePagRef) this.$refs.baseTablePagRef.focus() 
          })
          this.doFeedback('Se han refrescado los datos del grid actual', 'info', 3000, true)
        }, 200)
      }
      this.showNewTramite = data.PermitePresentar

      return data
    },
    applyFiltersHandler: async function (eventData) {
      this.$store.commit(this.vuexnamespace + '/setCurrentPage', 1)
      this.data = await this.applyFilters(eventData)
    },
    changeCurrentPage: async function (event) {
      this.$store.commit(this.vuexnamespace + '/setCurrentPage', event)
      this.data = await this.applyFilters(null)
    },
    changePerPage: async function (event) {
      this.$store.commit(this.vuexnamespace + '/setCurrentPage', 1)
      this.$store.commit(this.vuexnamespace + '/setPageSize', event)
      this.kendo.take = event
      this.data = await this.applyFilters(null)
    },
    removeFilterTagHanlder: function (tag) {
      // this.$store.commit(this.vuexnamespace + '/removeTag', tag)
      this.$store.commit(this.vuexnamespace + '/setCurrentPage', 1)
      const filter = this.$store.getters[this.vuexnamespace + '/getAppliedFilters']
      delete filter[tag[0]]
      this.$store.commit(this.vuexnamespace + '/setMasterFilters', filter)
      this.applyFiltersHandler(null)
    },
    headerCoreFiltersHandler: function (obs) {
      if (this.isHeadCoreReady) {
        this.applyFilters(null)
      }
    },
    removeAllTagsHandler: function () {
      this.$store.commit(this.vuexnamespace + '/setCurrentPage', 1)
      this.$store.commit(this.vuexnamespace + '/resetMasterFilters')
      this.applyFiltersHandler(null)
    },
    tableSortByChangeHandler: function ({ prop, order }) {
      this.$store.commit(this.vuexnamespace + '/setSort', prop)
      this.$store.commit(this.vuexnamespace + '/setSortOrder', order)
      this.$store.commit(this.vuexnamespace + '/setCurrentPage', 1)
      this.applyFilters(null)
    },
    unselect: function () {
      const checked = false
      this.mapSelectionKendoGrouping(checked)
      this.updateAllSelectedHeader()
    },
    goToNewPresentation: function () {
      this.$router.push({ name: 'presentation/new', params: { id: this.$route.params.id, type: this.$route.params.type } })
    },
    onHeaderSelectionChange: function (event) {
      const checked = event.event.target.checked
      this.mapSelectionKendoGrouping(checked)
      this.updateAllSelectedHeader()
    },
    onSelectionChange: function (event) {
      event.dataItem[this.selectedField] = !event.dataItem[this.selectedField]
      this.selected = event.dataItems.filter(d => d.selected === true)
      this.updateAllSelectedHeader()
    },
    toggleSearchesDialog: function () {
      this.searchesPanel = !this.searchesPanel
    },
    saveTagsHandler: function () {
      this.saveSearchDialog = !this.saveSearchDialog
    },
    toggleDialogSearches: function () {
      this.saveSearchDialog = !this.saveSearchDialog
    },
    applySearchHandler: async function () {
      this.toggleDialogSearches()
      // Manda actualizar lista de búsquedas
      this.$refs.filterPanelSearches.updateData()
    },
    updateNumberSearches: async function (number) {
      this.numberSearches = number
    },
  }
}
</script>

